export default "__VITE_ASSET__8yUIEQFR__"